import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'antd'
import { IconKey } from '../../../../shared/components/icons/IconKey'

interface KeywordsCountCellProps {
  id: number
  keywords_count: number
  is_demo: boolean
}

export const KeywordsCountCell = ({ id, keywords_count, is_demo }: KeywordsCountCellProps) => {
  const navigate = useNavigate()

  return (
    <div className={'flex items-center gap-[8px]'}>
      <div
        className={`w-fit ${
          is_demo ? 'cursor-default' : 'cursor-pointer border-b border-dotted text-focus'
        }`}
        onClick={() => !is_demo && navigate(`/projects/${id}/keywords`)}
      >
        {keywords_count}
      </div>
      {keywords_count === 0 && !is_demo && (
        <Tooltip title={'Missing keywords for this project. Add keywords to start gathering data.'}>
          <div className={'w-[20px] rounded-full bg-[#ff497d] p-[3px]'}>
            <IconKey color={'#FFFFFF'} />
          </div>
        </Tooltip>
      )}
    </div>
  )
}
